import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormPropInterface } from '../../../../core/interfaces/form-prop.interface';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {

  /**
   * @description Instancia del modelo con datos para el botón
   */
  @Input() public DATA_BUTTON: FormPropInterface;

  /**
   * @description Emision del evento de click
   */
  @Output() public EV_CLICK: EventEmitter<any> = new EventEmitter<any>();
  /**
   * @ignore
   */
  constructor() { }

  /**
   * @description Emitimos el evento click sobre el botón al exterior
   */
  toClick(objectToOutput?: any): void {
    this.EV_CLICK.emit(objectToOutput);
  }

}
